import { ProjectLayout, loadProjectOverview } from "@/components/projects/project-layout";
import { createFileRoute } from "@tanstack/react-router";

/**
 * `/projects/:slug` — project layout. Owns the project header +
 * the `ProjectTabs` sub-nav and renders the active sub-route in
 * its `<Outlet>`. The loader fetches `/api/projects/:slug/overview`
 * once; child routes read it back via
 * `useLoaderData({ from: "/_app/projects/$slug" })`.
 *
 * The shell and loader live in `@/components/projects/project-layout`
 * so the GitLab-native `/{group}/{project}` route can reuse them
 * without importing from this route file.
 */
export const Route = createFileRoute("/_app/projects/$slug")({
  loader: ({ params }) => loadProjectOverview(params.slug),
  component: ProjectLayoutRoute,
});

function ProjectLayoutRoute() {
  return <ProjectLayout data={Route.useLoaderData()} />;
}
